export default {
  title: 'Mobile not supported',
  text: 'The page you are trying to access is not supported on mobile devices. Please open the ETZ Admin/Employer web panel on your computer.',
};
